import { useEffect, useState } from 'react'
import '../src/assets/scss/app.scss'
import LogoWhite from './assets/images/logo-white.svg'
import UserCircle from './assets/images/user-circle.svg'
import Menu from './assets/images/menu.svg'
import BannerHeader from './assets/images/header-banner.png'
import StepCircle from './components/StepCircle'
import Arrow from './assets/images/arrow-right.svg'
import Accordion from './components/Accordion'
import Divider from './components/Divider'
import BannerLeads from './assets/images/banner-leads.png'
import BannerDream from './assets/images/banner-dreams.png'
import FeatureTexto from './assets/images/feature-modo-texto.png'
import FeatureIlustrativo from './assets/images/feature-modo-ilustrativo.png'
import FeatureTemas from './assets/images/feature-temas.png'
import FeatureEditor from './assets/images/feature-editor-page.png'
import FeatureArquivos from './assets/images/feature-arquivos.png'
import OctoUser from './assets/images/octo-user.svg'
import WindowSvg from './assets/images/window.svg'
import BannerDashboard from './assets/images/banner-dashboard.png'
import BannerMarketing from './assets/images/banner-marketing.png'
import {
  BookOpen,
  Files,
  Headphones,
  LayoutTemplate,
  Mail,
  Palette,
  Phone,
  Share2
} from 'lucide-react'
import VideoBox from './components/VideoBox'
import Modal from 'react-modal'
import CardPlan, { PlanProps } from './components/CardPlan'

Modal.setAppElement('#root')

type Props = {
  title: string
  content: string
}

const INTRO_VIDEO_ID = '6ac1541b15f0f5e3cd631bb4'
const PRODUCT_VIDEO_ID = '69dd3b20530b44eda4bf616e'

function App() {
  const planFeatures = [
    {
      icon: BookOpen,
      title: 'Modo texto',
      description: 'Capítulos corridos, até 30 páginas, com a margem do miolo.'
    },
    {
      icon: Palette,
      title: 'Modo ilustrativo',
      description:
        'Até 20 páginas. A criação gera a capa e as cenas, fora da cota diária.'
    },
    {
      icon: LayoutTemplate,
      title: 'Temas e editor',
      description:
        'Tema pronto ou por descrição. Uma página por vez, no formato da folha.'
    },
    {
      icon: Files,
      title: 'PDF e EPUB',
      description: 'Capa, sobrecapa e miolo. EPUB para leitura digital e Kindle.'
    },
    {
      icon: Headphones,
      title: 'Narração',
      description: 'Áudio em português e inglês, com histórico por ebook.'
    },
    {
      icon: Share2,
      title: 'Publicar',
      description:
        'Aberto ou privado, página de captura, lista de leads e capa própria.'
    }
  ]

  const planItems = [
    'Modo texto, até 30 páginas',
    'Modo ilustrativo, até 20 páginas, com capa e cenas <span>Novo</span>',
    'Narração em português e inglês, com histórico',
    'PDF com capa, sobrecapa e miolo',
    'EPUB para leitura digital e Kindle <span>Novo</span>',
    'Temas prontos ou gerados por uma descrição',
    'Editor página a página e modelos de layout',
    'Ebook aberto ou privado',
    'Página de captura, lista de leads e exportação',
    'Capa própria para a miniatura',
    'Ebook em português, inglês e espanhol',
    'Suporte no horário comercial'
  ]

  const faq: Props[] = [
    {
      title: 'Quais arquivos eu recebo?',
      content:
        'PDF, com capa, sobrecapa e miolo, no formato e nas margens do ebook. EPUB para leitura digital e Kindle, com a capa em retrato 1600×2560. E a narração do texto em áudio, em português (Brasil) e inglês (Estados Unidos). Depois de mudar texto, tema ou modelo de página, use Atualizar PDF.'
    },
    {
      title: 'Em quais idiomas dá para criar?',
      content:
        'Na criação você escolhe o idioma do ebook. Os planos incluem português, inglês e espanhol. A narração em áudio está disponível em português (Brasil) e inglês (Estados Unidos).'
    },
    {
      title: 'Quantas páginas o ebook pode ter?',
      content:
        'No modo texto, até 30 páginas. No modo ilustrativo, até 20. O que não cabe numa folha continua na seguinte, dentro desse total. No modo texto, as margens do miolo valem em todas as folhas. No ilustrativo, a imagem encosta na borda da folha.'
    },
    {
      title: 'Dá para incluir imagens?',
      content:
        'Sim. No modo ilustrativo, a criação do livro gera a capa e as imagens das cenas, e essa geração não consome a cota diária. A cota vale para ações individuais: gerar ou trocar uma imagem depois. No modo texto, a sobrecapa entra se você pedir, e os modelos de página também aceitam imagem. A troca é feita pela galeria.'
    },
    {
      title: 'Tenho suporte após adquirir o Ebook Generator?',
      content:
        'Dentro da ferramenta, nossa equipe está sempre disponível para ajudá-lo durante o horário comercial. Além disso, como assinante, você é bem-vindo para sugerir novos recursos e melhorias.'
    },
    // {
    //   title: 'Onde assisto as aulas oferecidas pelo Ebook Generator?',
    //   content:
    //     'Dentro da ferramenta, há uma seção "Aulas". Ela é facilmente acessível para que você possa estudar e aplicar imediatamente 😄'
    // },
    {
      title: 'O conteúdo gerado possui direitos autorais?',
      content:
        'Todo o conteúdo gerado, incluindo ebooks, pertence a você. Como utilizamos inteligência artificial, o conteúdo é único e gerado instantaneamente.'
    },
    {
      title: 'Como funciona a personalização do ebook?',
      content:
        'Você parte de um tema padrão ou descreve cores, clima e fonte para gerar um tema. Os temas que você cria aparecem na frente dos padrões. Dá para ajustar fundo, cor do texto da capa, cor do texto do miolo, cor de acento e a família tipográfica. A capa usa arte em SVG na proporção A5, com o título quebrando a linha. Há preview da capa, da sobrecapa, do miolo, da página ilustrada e do sumário, em A5, A4 ou Letter. Um tema padrão pode ser duplicado e editado. O original permanece na biblioteca. O tema aplicado pinta capa, miolo e sumário no editor e no PDF.'
    },
    {
      title: 'Como funciona o áudio?',
      content:
        'A narração lê o texto do ebook em português (Brasil) ou inglês (Estados Unidos). Cada ebook guarda o histórico, e você pode gerar outro áudio se o anterior não servir. Há um limite de tamanho do texto e um intervalo entre gerações.'
    },
    {
      title: 'Consigo publicar e saber quem baixou?',
      content:
        'Sim. O ebook pode ficar aberto ou privado. Cada um tem uma página de captura de e-mail, com a lista dos leads e exportação. A miniatura pode ser uma capa que você envia, separada da arte do tema.'
    },
    {
      title: 'Existe alguma restrição de tema para a criação do ebook?',
      content:
        'No Ebook Generator, acreditamos na liberdade de expressão e na diversidade de ideias. Portanto, não impomos restrições de tema para a criação do ebook. Você é livre para escolher qualquer assunto que desejar, seja ficção, não-ficção, educacional, auto-ajuda, culinária, entre outros. No entanto, é importante observar que o conteúdo do ebook deve estar em conformidade com as leis e regulamentos locais e internacionais. Não permitimos a criação de conteúdo que promova o ódio, a discriminação, a violência ou qualquer forma de atividade ilegal.'
    }
  ]
  const plan: PlanProps = {
    title: 'Plano mensal',
    recurrency: 'Mensal',
    subtitle: 'Pagamento mensal',
    price: '39,90',
    url: 'https://nexux.ai/checkout/ebook-generator-mensal-2026/plan',
    items: planItems
  }

  const [referrer, setReferrer] = useState('')
  const [utmSource, setUtmSource] = useState('')
  const [menuOpen, setMenuOpen] = useState(false)

  useEffect(() => {
    setReferrer(document.referrer)
    setUtmSource(document.location.search)
  }, [])

  return (
    <div className="app">
      {/* <div className="header-bf">
        <p>Aproveite nossa oferta de </p>

        <a href="#plans">
          <div className="black-november">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 9H9.01M15 15H15.01M16 8L8 16M7.33377 3.8187C8.1376 3.75455 8.90071 3.43846 9.51447 2.91542C10.9467 1.69486 13.0533 1.69486 14.4855 2.91542C15.0993 3.43846 15.8624 3.75455 16.6662 3.8187C18.5421 3.96839 20.0316 5.45794 20.1813 7.33377C20.2455 8.1376 20.5615 8.90071 21.0846 9.51447C22.3051 10.9467 22.3051 13.0533 21.0846 14.4855C20.5615 15.0993 20.2455 15.8624 20.1813 16.6662C20.0316 18.5421 18.5421 20.0316 16.6662 20.1813C15.8624 20.2455 15.0993 20.5615 14.4855 21.0846C13.0533 22.3051 10.9467 22.3051 9.51447 21.0846C8.90071 20.5615 8.1376 20.2455 7.33377 20.1813C5.45794 20.0316 3.96839 18.5421 3.8187 16.6662C3.75455 15.8624 3.43846 15.0993 2.91542 14.4855C1.69486 13.0533 1.69486 10.9467 2.91542 9.51447C3.43846 8.90071 3.75455 8.1376 3.8187 7.33377C3.96839 5.45794 5.45794 3.96839 7.33377 3.8187ZM9.5 9C9.5 9.27614 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.27614 8.5 9C8.5 8.72386 8.72386 8.5 9 8.5C9.27614 8.5 9.5 8.72386 9.5 9ZM15.5 15C15.5 15.2761 15.2761 15.5 15 15.5C14.7239 15.5 14.5 15.2761 14.5 15C14.5 14.7239 14.7239 14.5 15 14.5C15.2761 14.5 15.5 14.7239 15.5 15Z"
                stroke="url(#paint0_linear_8_1662)"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_8_1662"
                  x1="12"
                  y1="2"
                  x2="12"
                  y2="22"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FFD500" />
                  <stop offset="1" stop-color="#C27A08" />
                </linearGradient>
              </defs>
            </svg>
            <p>Black November</p>
          </div>
        </a>
      </div> */}

      <header id="home" className="topbar">
        <div className="topbar-inner">
          <a href="/">
            <img src={LogoWhite} alt="Ebook Generator" />
          </a>

          <nav className="header-nav" aria-label="Seções">
            <a href="#modos">Modos</a>
            <a href="#temas">Temas</a>
            <a href="#editor">Editor</a>
            <a href="#arquivos">Arquivos</a>
          </nav>

          <div className={`dropdown ${menuOpen ? 'is-open' : ''}`}>
            <button
              type="button"
              className="menu"
              aria-expanded={menuOpen}
              aria-label="Abrir menu"
              onClick={() => setMenuOpen((open) => !open)}
            >
              <img src={Menu} alt="" />
            </button>

            <nav className="header-buttons">
              <div className="header-nav-mobile">
                <a href="#modos" onClick={() => setMenuOpen(false)}>
                  Modos
                </a>
                <a href="#temas" onClick={() => setMenuOpen(false)}>
                  Temas
                </a>
                <a href="#editor" onClick={() => setMenuOpen(false)}>
                  Editor
                </a>
                <a href="#arquivos" onClick={() => setMenuOpen(false)}>
                  Arquivos
                </a>
              </div>
              <a href="https://app.ebookgenerator.ai" className="ghost-link">
                <img src={UserCircle} alt="" />
                Login
              </a>

              <a href="#plans" className="button-link">
                Criar conta
              </a>
            </nav>
          </div>
        </div>
      </header>

      <div className="sub-header">
        <div className="first">
          <p className="kicker">Livro e audiobook no mesmo lugar</p>
          <p className="title">Seu livro e o áudio, prontos para ler ou vender</p>
          <p className="subtitle">
            Descreva o tema. A IA monta o ebook em capítulos ou em páginas
            ilustradas, com capa, sumário e narração. Você revisa e publica
            para quem quiser baixar.
          </p>
          <a
            href="#plans"
            title="Gerar meu primeiro ebook"
            className="btn btn-primary btn-size-lg"
          >
            Gerar meu primeiro ebook
          </a>
          <a href="#modos" className="text-link">
            Ver o que a ferramenta faz
          </a>
        </div>

        <div className="second">
          <img src={BannerHeader} alt="IA Trabalhando" />
        </div>
      </div>

      <main id="about">
        <VideoBox
          id={INTRO_VIDEO_ID}
          title="Ebook Generator"
          autoPlay
        />

        <section className="section-header">
          <h1 className="title">Plataforma de geração de ebooks</h1>
          <h2 className="subtitle">
            Do pedido ao arquivo, em <strong>poucos passos</strong>
          </h2>

          <article className="steps">
            <div className="card-step">
              <StepCircle n={1} />
              <p>Descreva título, autor, tema e idioma</p>
            </div>
            <img src={Arrow} alt="" />
            <div className="card-step">
              <StepCircle n={2} />
              <p>Escolha o modo, o formato da folha e o visual</p>
            </div>
            <img src={Arrow} alt="" />
            <div className="card-step">
              <StepCircle n={'✌'} />
              <p>Revise no editor e leve em PDF, EPUB ou áudio</p>
            </div>
          </article>
        </section>

        <Divider />

        <div className="product">
          <section className="block" id="modos">
            <div className="section-intro">
              <p className="kicker">Dois modos</p>
              <h2>O formato acompanha o tipo de livro</h2>
              <p>
                A escolha fica no último passo. Nos dois modos entram título,
                autor, descrição, idioma, tema e o formato da folha.
              </p>
              <div className="chips" aria-label="Formatos de folha">
                <span>A5</span>
                <span>A4</span>
                <span>Letter</span>
                <span>Medida própria, em mm ou in</span>
              </div>
            </div>

            <div className="card-grid two">
              <article className="info-card">
                <img
                  src={FeatureTexto}
                  alt="Miolo em modo texto, com capítulos corridos e margem"
                />
                <div className="info-body">
                  <h3>Modo texto</h3>
                  <p>
                    Capítulos corridos, até 30 páginas. A leitura segue de uma
                    folha para a outra, com as margens do miolo. Cabe em guia,
                    ensaio, apostila e narrativa longa.
                  </p>
                  <ul>
                    <li>Sobrecapa, se você pedir na criação</li>
                    <li>Sumário montado a partir dos títulos</li>
                    <li>Todos os modelos de página, inclusive os com imagem</li>
                  </ul>
                </div>
              </article>

              <article className="info-card">
                <img
                  src={FeatureIlustrativo}
                  alt="Capa com arte geométrica e página ilustrada de ponta a ponta"
                />
                <div className="info-body">
                  <h3>
                    Modo ilustrativo <span className="tag">Novo</span>
                  </h3>
                  <p>
                    Até 20 páginas. Cada página é uma cena: imagem e um texto
                    curto. A criação já gera a capa e as imagens das cenas, e
                    essa geração não entra na cota diária.
                  </p>
                  <ul>
                    <li>
                      A cota vale só para gerar ou trocar uma imagem depois
                    </li>
                    <li>A imagem encosta na borda da folha, como no PDF</li>
                    <li>Sumário a partir do título de cada cena</li>
                    <li>
                      Modelos de imagem em cima, ao lado, página inteira ou só
                      texto
                    </li>
                  </ul>
                </div>
              </article>
            </div>
          </section>

          <section className="feature-split" id="temas">
            <article>
              <p className="kicker">Temas</p>
              <h2>O visual pinta capa, miolo e sumário</h2>
              <p>
                Os temas que você cria ficam na frente dos padrões. Use um tema
                pronto ou descreva cores, clima e fonte. Se quiser partir de um
                padrão, duplique e edite a cópia. O original continua na
                biblioteca.
              </p>
              <ul className="feature-list">
                <li>
                  Fundo, cor do texto da capa, cor do texto do miolo, cor de
                  acento e família tipográfica
                </li>
                <li>
                  Capa com arte em SVG na proporção A5. O desenho cabe na folha
                  e o título quebra a linha
                </li>
                <li>
                  Preview da capa, sobrecapa, miolo, página ilustrada e sumário,
                  em A5, A4 ou Letter
                </li>
                <li>O tema aplicado aparece no editor e no PDF</li>
              </ul>
            </article>
            <img src={FeatureTemas} alt="Paleta, previews e capa do tema" />
          </section>

          <section className="feature-split media-first" id="editor">
            <img
              src={FeatureEditor}
              alt="Editor com uma folha e os modelos de página"
            />
            <article>
              <p className="kicker">Editor</p>
              <h2>Uma página por vez, no papel escolhido</h2>
              <p>
                O que não cabe na folha continua na seguinte. O sumário sai dos
                títulos, sem repetir o mesmo item. Se a lista passar de uma
                folha, ela segue na próxima.
              </p>
              <div className="chips">
                <span>Padrão</span>
                <span>Início de capítulo</span>
                <span>Sumário</span>
                <span>Imagem em cima</span>
                <span>Imagem ao lado</span>
                <span>Imagem em página inteira</span>
                <span>Só texto</span>
              </div>
              <p>
                No modo texto, as margens do miolo valem em todas as folhas. No
                ilustrativo, a imagem encosta na borda, como no arquivo final.
                A imagem da página troca pela galeria. Regenerar as cenas do
                livro ilustrado é uma ação individual e respeita a cota do dia.
              </p>
            </article>
          </section>

          <section className="block" id="arquivos">
            <div className="section-intro">
              <p className="kicker">Arquivos</p>
              <h2>PDF, EPUB e a narração do texto</h2>
              <p>
                O mesmo livro sai para ler na tela, para ouvir e para guardar
                em PDF. Os arquivos ficam com você, para uso próprio ou para
                comercializar.
              </p>
            </div>
            <img
              className="feature-wide"
              src={FeatureArquivos}
              alt="PDF impresso, leitor digital e narração em áudio"
            />
            <div className="card-grid three">
              <article className="info-card">
                <div className="info-body">
                  <h3>PDF</h3>
                  <p>
                    Capa, sobrecapa e miolo, no formato e nas margens do ebook.
                    Depois de mudar texto, tema ou modelo de página, use
                    Atualizar PDF.
                  </p>
                </div>
              </article>
              <article className="info-card">
                <div className="info-body">
                  <h3>EPUB</h3>
                  <p>
                    Leitura digital e Kindle. A capa do EPUB usa o retrato
                    1600×2560.
                  </p>
                </div>
              </article>
              <article className="info-card">
                <div className="info-body">
                  <h3>Áudio</h3>
                  <p>
                    Narração em português (Brasil) e inglês (Estados Unidos).
                    Cada ebook guarda o histórico. Se a versão não servir, você
                    gera outra. Há limite de tamanho do texto e um intervalo
                    entre gerações.
                  </p>
                </div>
              </article>
            </div>
          </section>
        </div>

        <Divider />

        <section className="leads">
          <img src={BannerLeads} alt="Leads" />

          <article>
            <img src={OctoUser} alt="Lead de usuários" />
            <h1>Saiba quem baixou e leve a lista com você</h1>
            <p>
              Cada ebook tem a própria página de captura. Os e-mails ficam na
              lista do livro e podem ser exportados, para você falar com quem
              se interessou.
            </p>
          </article>
        </section>

        <Divider />

        <section className="dream">
          <article>
            <img src={WindowSvg} alt="Invista com sabedoria" />
            <h1>Uma página para divulgar, aberta ou fechada</h1>
            <p>
              Deixe o ebook público ou privado. Quem chega deixa o e-mail antes
              do download. Se quiser outra miniatura, envie uma capa sua: ela
              fica separada da arte do tema.
            </p>
          </article>
          <img src={BannerDream} alt="Invista com sabedoria" />
        </section>

        <img
          className="dashboard"
          src={BannerDashboard}
          alt="Dashboard Ebook Generator"
        />

        <section className="plans" id="plans">
          <div className="plans-intro">
            <p className="kicker">Assinatura</p>
            <h2>Plano mensal</h2>
            <p>
              R$ 39,90 por mês. O mesmo acesso para quem cria o livro para si e
              para quem publica.
            </p>
          </div>

          <div className="plans-layout">
            <div className="plans-features">
              <h3>O que entra no plano</h3>
              <ul>
                {planFeatures.map((feature) => {
                  const Icon = feature.icon
                  return (
                    <li key={feature.title}>
                      <span>
                        <Icon size={18} aria-hidden="true" />
                      </span>
                      <div>
                        <strong>{feature.title}</strong>
                        <p>{feature.description}</p>
                      </div>
                    </li>
                  )
                })}
              </ul>
              <VideoBox
                id={PRODUCT_VIDEO_ID}
                title="Apresentação Ebook Generator"
              />
            </div>

            <div className="plans-cards">
              <CardPlan
                recurrency={plan.recurrency}
                title={plan.title}
                subtitle={plan.subtitle}
                price={plan.price}
                items={plan.items}
                url={`${plan.url}/?referer=${referrer}${utmSource.replace(
                  '?',
                  '&'
                )}`}
              />
            </div>
          </div>
        </section>

        <section className="end-section">
          <h1 className="title-animation">
            <span>Crie, Divulgue, Conquiste. Crie, Divulgue, Conquiste.</span>
            <span>Crie, Divulgue, Conquiste. Crie, Divulgue, Conquiste.</span>
            <span>Crie, Divulgue, Conquiste. Crie, Divulgue, Conquiste.</span>
          </h1>

          <article>
            <div className="container">
              <div>
                <header>
                  <h1>Do arquivo à lista de leitores</h1>
                  <p>
                    Publique o ebook como produto ou como porta de entrada. A
                    página pede o e-mail de quem baixa. PDF, EPUB e áudio ficam
                    com você.
                  </p>
                </header>

                <a
                  href="#plans"
                  // onClick={handleOpenModal}
                  className="btn btn-primary btn-size-lg"
                >
                  Quero criar meu ebook
                </a>
              </div>

              <img src={BannerMarketing} alt="Estratégia de Marketing" />
            </div>
          </article>
        </section>

        <section className="faq">
          <article>
            <h1>Dúvidas frequentes</h1>
            <p>
              Ainda tem dúvidas? Confira as perguntas mais recorrentes e acelere
              seu processo!
            </p>
          </article>

          <div id="faq">
            <Accordion items={faq} />
          </div>
        </section>
      </main>

      <footer>
        <div className="footer-line" />
        <div className="footer-main">
          <div className="footer-brand">
            <a href="#home">
              <img src={LogoWhite} alt="Ebook Generator" />
            </a>
            <p>
              Ebooks e narração em áudio com inteligência artificial. Você cria,
              revisa página a página e publica para usar ou comercializar.
            </p>
            <div className="footer-address">
              <span>CNPJ: 42.002.718/0001-67</span>
              <span>Rua Cel. Jose Eusebio, 95 Casa 13</span>
              <span>CEP: 01239-030 - Higienopolis São Paulo SP</span>
            </div>
          </div>

          <nav aria-label="Navegação">
            <h2>Navegação</h2>
            <a href="#home">Início</a>
            <a href="#modos">Modos</a>
            <a href="#plans">Planos</a>
            <a href="#faq">FAQ</a>
            <a href="https://app.ebookgenerator.ai">Entrar</a>
          </nav>

          <nav aria-label="Afiliados">
            <h2>Afiliados</h2>
            <a href="https://nexux.ai/afiliados" target="_blank" rel="noreferrer">
              Programa de Afiliados
            </a>
            <a
              href="https://nexux.ai/afiliados/cadastro"
              target="_blank"
              rel="noreferrer"
            >
              Pré-cadastro
            </a>
            <a
              href="https://nexux.ai/afiliados/login"
              target="_blank"
              rel="noreferrer"
            >
              Login
            </a>
            <a
              href="https://nexux.ai/afiliados#como-funciona"
              target="_blank"
              rel="noreferrer"
            >
              Como Funciona
            </a>
            <a
              href="https://nexux.ai/afiliados/termos"
              target="_blank"
              rel="noreferrer"
            >
              Termos e Políticas
            </a>
          </nav>

          <nav aria-label="Legal">
            <h2>Legal</h2>
            <a
              href="https://nexux.ai/termos-de-uso"
              target="_blank"
              rel="noreferrer"
            >
              Termos de Uso
            </a>
            <a
              href="https://nexux.ai/politica-de-privacidade"
              target="_blank"
              rel="noreferrer"
            >
              Política de Privacidade
            </a>
            <a
              href="https://nexux.ai/politica-de-garantia-e-reembolso"
              target="_blank"
              rel="noreferrer"
            >
              Política de Garantia e Reembolso
            </a>
            <a
              href="https://nexux.ai/politica-de-cookies"
              target="_blank"
              rel="noreferrer"
            >
              Política de Cookies
            </a>
          </nav>

          <nav aria-label="Suporte">
            <h2>Suporte</h2>
            <a href="#faq">FAQ</a>
            <a href="https://suporte.nexux.ai" target="_blank" rel="noreferrer">
              Contato
            </a>
            <a
              href="https://api.whatsapp.com/send/?phone=554884877366&text=Ol%C3%A1%2C+quero+falar+com+o+suporte+da+Nexux+AI&type=phone_number&app_absent=0&fbclid=PAZXh0bgNhZW0CMTEAAadMWdX84uACpsMIPsqg2ThfxCAhnvDdHjAWbpHmekWyy43KftIcQU2WxLM-NQ_aem_FFYMgLTOBSCVwpW2P8POwQ"
              target="_blank"
              rel="noreferrer"
            >
              <Phone size={16} aria-hidden="true" />
              WhatsApp
            </a>
            <a href="mailto:atendimento@nexux.ai">
              <Mail size={16} aria-hidden="true" />
              Email
            </a>
          </nav>
        </div>

        <div className="footer-bar">
          <p>© {new Date().getFullYear()} Nexux AI LTDA. Todos os direitos reservados.</p>
          <div>
            <a
              href="https://nexux.ai/termos-de-uso"
              target="_blank"
              rel="noreferrer"
            >
              Termos
            </a>
            <span aria-hidden="true">•</span>
            <a
              href="https://nexux.ai/politica-de-privacidade"
              target="_blank"
              rel="noreferrer"
            >
              Privacidade
            </a>
            <span aria-hidden="true">•</span>
            <a
              href="https://nexux.ai/politica-de-garantia-e-reembolso"
              target="_blank"
              rel="noreferrer"
            >
              Reembolso
            </a>
            <span aria-hidden="true">•</span>
            <a
              href="https://nexux.ai/politica-de-cookies"
              target="_blank"
              rel="noreferrer"
            >
              Cookies
            </a>
            <span aria-hidden="true">•</span>
            <a
              href="https://wa.me/5548984877366"
              target="_blank"
              rel="noreferrer"
            >
              Suporte
            </a>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default App
